import React from 'react';

import { RegistroAtividadeProvider } from './registroAtividades';
import { RegColheitaManualProvider } from './registroColheitaManual';
import { RegColheitaPorPeProvider } from './registroColheitaPorPe';
import { RegColheitaMecanicaProvider } from './registroColheitaMecanica';
import { RegExtrasProvider } from './registroExtras';
import { RegInsumosProvider } from './registroInsumos';
import { RegCaldaProvider } from './registroCaldas';
import { RegMaquinasProvider } from './registroMaquinas';
import { RegMdobrasProvider } from './registroMdobra';
import { RegImagesProvider } from './registroImages';
import { RegColheitaSimplificadaProvider } from './registroColheitaSimplificada';
import { RegAtividadesTimelineProvider } from './registroAtividadesTimeline';

function RegistrosProvider({ children }) {
  return (
    <RegColheitaManualProvider>
      <RegColheitaPorPeProvider>
        <RegColheitaMecanicaProvider>
          <RegExtrasProvider>
            <RegInsumosProvider>
              <RegCaldaProvider>
                <RegMaquinasProvider>
                  <RegMdobrasProvider>
                    <RegColheitaSimplificadaProvider>
                      <RegAtividadesTimelineProvider>
                        <RegistroAtividadeProvider>
                          <RegImagesProvider>{children}</RegImagesProvider>
                        </RegistroAtividadeProvider>
                      </RegAtividadesTimelineProvider>
                    </RegColheitaSimplificadaProvider>
                  </RegMdobrasProvider>
                </RegMaquinasProvider>
              </RegCaldaProvider>
            </RegInsumosProvider>
          </RegExtrasProvider>
        </RegColheitaMecanicaProvider>
      </RegColheitaPorPeProvider>
    </RegColheitaManualProvider>
  );
}

export { RegistrosProvider };
